<template>
  <path
    d="M19 8.00016V11.0002H5.82998L8.70998 8.12016C9.09998 7.73016 9.09998 7.10016 8.70998 6.71016C8.31998 6.32016 7.68998 6.32016 7.29998 6.71016L2.70998 11.3002C2.31998 11.6902 2.31998 12.3202 2.70998 12.7102L7.29998 17.3002C7.68998 17.6902 8.31998 17.6902 8.70998 17.3002C9.09998 16.9102 9.09998 16.2802 8.70998 15.8902L5.82998 13.0002H20C20.55 13.0002 21 12.5502 21 12.0002V8.00016C21 7.45016 20.55 7.00016 20 7.00016C19.45 7.00016 19 7.45016 19 8.00016Z"
  />
</template>
